import { buildKeyLearningPrompt } from './aiPrompts'

const KEY_LEARNING_CHAR_LIMIT = 2000

export const KEY_LEARNING_CONFIG = {
  systemPrompt: buildKeyLearningPrompt(KEY_LEARNING_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    year: v.year,
    frenchProgram: v.frenchProgram,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    esl: v.esl,
    iep: v.iep,
  }),
}
